import { render, staticRenderFns } from "./DefectsFilled.vue?vue&type=template&id=d9daad60"
import script from "./DefectsFilled.vue?vue&type=script&setup=true&lang=js"
export * from "./DefectsFilled.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports